import { REFUND_STATE } from "@zhihaoscm/meta";

/** 退款状态统一复用 Vue 元数据，避免已下线的“待退款”状态在任一 React 页面重新出现。 */
export const REFUND_STATE_LABELS = Object.fromEntries(
    REFUND_STATE.options.map(option => [Number(option.value), option.label])
) as Record<number, string>;

/** 退款筛选选项与列表、详情状态文案保持同一份来源。 */
export const REFUND_STATE_OPTIONS = REFUND_STATE.options.map(option => ({
    value: String(option.value),
    label: option.label
}));
